module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap10"
    }
  }, [_vm._v("TWO")]), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v("Summer of Devils and Angels")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("LAST DAY OF SCHOOL — Barbershop Talk — A Boy and a Ball — I Get Around — Welcome, Lucifer — Nemo’s Mother & a Week with the Jaybird — My Camping Trip — Chile Willow — Summer Winds Up")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d55a8d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book3/14-chap10.vue
// module id = 117
// module chunks = 0